




















































import {SearchResult} from '../../models/search-result-model';

import InviewDirective from '@/shared/directives/inview-directive';
import LinkDirective from '@/shared/directives/link-directive';
import LinksDirective from '@/shared/directives/links-directive';

import DefaultResultCard from './DefaultResultCard.vue';
import ImageResultCard from './ImageResultCard.vue';

import DefaultDetails from './DefaultDetails.vue';
import AgendaDetails from './AgendaDetails.vue';
import CategoryDetails from './CategoryDetails.vue';

import ImageRatioMolecule from '@/shared/components/molecules/ImageRatioMolecule.vue'
import {defineComponent, PropType} from "@vue/composition-api";
import {useState} from "vuex-composition-helpers";
import TopEducationResultCard from "@/apps/SearchWidget/components/VU/TopEducationResultCard.vue";

export default defineComponent({
  name: 'VUSearchResultCard',
  components: {
    DefaultResultCard,
    ImageResultCard,
    DefaultDetails,
    AgendaDetails,
    CategoryDetails,
    ImageRatioMolecule,
    TopEducationResultCard
  },
  directives: {
    InviewDirective,
    LinkDirective,
    LinksDirective
  },
  props: {
    result: {type: Object as PropType<SearchResult>, required: true},
    index: {type: Number}
  },
  setup: (props) => {
    const {config, imageFallback, searchResultsCount} = useState(['config', 'imageFallback', 'searchResultsCount'])

    function layout(): string {
      if (showImage()) {
        return 'image-result-card';
      }

      if (isTopEducation()) {
        return 'top-education-result-card';
      }

      return 'default-result-card';
    }

    function detailsComponent(): string {
      if (config.value.showCategories) {
        return 'category-details';
      }

      if (isAgenda()) {
        return 'agenda-details';
      }

      return 'default-details';
    }

    function showImage(): boolean {
      let types = ["Agenda", "News", "Professionals", "HOVO Amsterdam", "VU Centre for Teaching & Learning", "SocialColumn", "EmployeeTheme", "Research", "VU-NT2"];

      if (props.result.types.includes("Portal")) {
        return false;
      }

      return types.some(x => props.result.types.includes(x));
    }

    function showSubtitleBefore(): boolean {
      return ["Agenda", "News"].some(x => props.result.types.includes(x));
    }

    function isAgenda(): boolean {
      return props.result.types.includes("Agenda");
    }

    function isTopEducation(): boolean {
      return props.result.tags.includes("TopEducation");
    }

      function trackSearchResultCardClick() {
          if (typeof window !== "undefined" && (window as any).dataLayer) {
              const searchQuery = (document.getElementById("query") as HTMLInputElement)?.value || '';

              const pageTitle = document.querySelector('[data-widget="title-bar"] h1')?.textContent?.trim();

              (window as any).dataLayer.push({
                  event: "search_overview_click",
                  click_text: props.result.title,
                  page_title: pageTitle,
                  search_query: searchQuery,
                  search_display: searchResultsCount.value
              });
          }
      }

    return {
      config,
      imageFallback,
      layout,
      detailsComponent,
      showSubtitleBefore,
      trackSearchResultCardClick
    }
  }
})
